module.exports = __webpack_public_path__ + "static/media/feed-insta-extends.289bfec8.png";